import React from 'react';
import './TemplatesSection.css';
import { FaUser, FaBriefcase, FaCheckCircle, FaArrowRight } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const TemplatesSection = () => {
  const { t } = useTranslation();
  const steps = [
    { icon: FaUser, code: '01', key: 'step1' },
    { icon: FaBriefcase, code: '02', key: 'step2' },
    { icon: FaCheckCircle, code: '03', key: 'step3' }
  ];

  return (
    <section className="wb-protocol-section" id="third-div">
      <div className="wb-protocol-grid" aria-hidden="true" />
      <div className="wb-protocol-shell">
        <div className="wb-protocol-heading">
          <div className="wb-protocol-kicker"><span /> {t('websiteUi.careerProtocol')}</div>
          <h2>{t('workflow.title')}</h2>
          <p>{t('website.protocolLead')}</p>
        </div>
        <div className="wb-protocol-flow">
          {steps.map(({ icon: Icon, code, key }, index) => (
            <React.Fragment key={key}>
              <article className="wb-protocol-step">
                <div className="wb-protocol-number">{code}</div>
                <div className="wb-protocol-icon"><Icon /></div>
                <div className="wb-protocol-content"><h3>{t(`workflow.${key}Title`)}</h3><p>{t(`workflow.${key}Text`)}</p></div>
                <span className="wb-protocol-state">{t('websiteUi.online')}</span>
              </article>
              {index < steps.length - 1 && <div className="wb-protocol-link"><span /><FaArrowRight /></div>}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TemplatesSection;
